import { render, staticRenderFns } from "./EditDocLabBact.vue?vue&type=template&id=215edb5e&scoped=true"
import script from "./EditDocLabBact.vue?vue&type=script&lang=js"
export * from "./EditDocLabBact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215edb5e",
  null
  
)

export default component.exports